import { keyBy } from 'lodash';
import i18next from 'i18next';
import React from 'react';

// Commons
import { Tooltip as InpulseTooltip } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_COLORS, ENUM_FONTS, OVERFLOW_STYLE_TEXT } from '@commons/Text';

// Style
import { Cell, Container, Label, Row } from './styledComponents';

const PackagingInfoDisplay = ({ transfers, packagings, showRequested = true, showSent = true }) => {
  const transferByPackagingId = keyBy(transfers, 'packaging.id');

  return (
    <Container>
      <Text font={ENUM_FONTS.TEXT_MIDDLE_BOLD}>{i18next.t('GENERAL.INFORMATIONS')}</Text>

      <Row>
        <Label /> {/* Empty for header */}
        {showRequested && (
          <Cell>
            <Text color={ENUM_COLORS.IP_BLACK_1} font={ENUM_FONTS.TEXT_SMALL}>
              {i18next.t('STOCKS.TRANSFERS.STATUS_REQUESTED')}
            </Text>
          </Cell>
        )}
        {showSent && (
          <Cell>
            <Text color={ENUM_COLORS.IP_BLACK_1} font={ENUM_FONTS.TEXT_SMALL}>
              {i18next.t('STOCKS.TRANSFERS.STATUS_SENT')}
            </Text>
          </Cell>
        )}
      </Row>

      {packagings.map(({ id, name }) => {
        const transfer = transferByPackagingId[id] || {};
        const { transferNoteQuantity = null, deliveryNoteQuantity = null } = transfer;

        return (
          <Row key={id}>
            <Label>
              <InpulseTooltip
                renderTooltipTrigger={() => (
                  <Text
                    color={ENUM_COLORS.IP_BLACK_4}
                    font={ENUM_FONTS.TEXT_SMALL}
                    style={OVERFLOW_STYLE_TEXT}
                  >
                    {name}
                  </Text>
                )}
                text={name}
                displayBigger
              />
            </Label>
            {showRequested && (
              <Cell>
                <Text color={ENUM_COLORS.IP_BLACK_4} font={ENUM_FONTS.TEXT_SMALL}>
                  {transferNoteQuantity !== null ? transferNoteQuantity : '--'}
                </Text>
              </Cell>
            )}
            {showSent && (
              <Cell>
                <Text color={ENUM_COLORS.IP_BLACK_4} font={ENUM_FONTS.TEXT_SMALL}>
                  {deliveryNoteQuantity !== null ? deliveryNoteQuantity : '--'}
                </Text>
              </Cell>
            )}
          </Row>
        );
      })}
    </Container>
  );
};

export default PackagingInfoDisplay;
